<div class="section" [class.border-bottom]="showHeader" [class.section-padding]="showHeader" [class.p-3]="!showHeader" [class.editing]="editing" [class.editable]="editable">
    @if (showHeader) {
        <div class="d-flex flex-row">
            @if (handler.icon) {
                <div title="{{ handler.onIconClicked && entity ? ('ADMIN.EDITOR.PICTURE_UPLOAD_TIP' | translate) : '' }}" (click)="onIconClicked()">
                    <div class="section-image mr-3" [class.pointer]="handler.onIconClicked && entity">
                        @if (handler.icon.startsWith("data:")) {
                            <img [src]="handler.icon" />
                        }
                        @if (!handler.icon.startsWith("data:")) {
                            <kui-icon class="section-icon icon-light" fixedWidth="true" [name]="handler.icon" [size]="'xl'"></kui-icon>
                        }
                        @if (handler.onIconClicked && entity) {
                            <kui-icon class="overlay" name="camera" size="lg"></kui-icon>
                        }
                    </div>
                </div>
            }
            <div class="center-column flex-1">
                <!-- floated, and so ahead of the title, which lets the title and the description
                     flow beside it and wrap under it when it leaves them too little room -->
                @if (handler && editable && !editing && !handler.readonly) {
                    <button kui-button class="section-edit" color="secondary" (click)="onEdit.emit()">
                        <!-- <kui-icon class="mr-2" name="edit" [size]="'sm'"></kui-icon> -->
                        <span class="dimmed-less">{{ "SHARED.EDIT" | translate }}</span>
                    </button>
                }
                <h4 class="title">{{ handler.title }}</h4>
                @if (handler.description) {
                    <div class="section-description muted">
                        {{ handler.description }}
                    </div>
                }
                <ng-content select="[inside]"></ng-content>
            </div>
        </div>
    }

    @if (handler.warning && !editing) {
        <div class="border py-2 px-3 mt-3">
            <kui-icon class="pr-2" name="warning" [size]="'sm'"></kui-icon>
            {{ handler.warning }}
        </div>
    }

    <ng-content select="[outside]"></ng-content>

    @if (!editing && staticActions.length) {
        <div class="buttons">
            <div class="flex-1 text-left">
                @for (action of staticActions; track action) {
                    <button kui-button class="mt-3" (click)="onAction.emit(action.id || action.name)" color="secondary" [kui-tooltip]="action.name">
                        @if (action.icon) {
                            <kui-icon kui-action name="action.icon" [size]="'sm'"></kui-icon>
                        }
                        {{ action.name }}
                    </button>
                }
            </div>
        </div>
    }

    @if (errorMessage) {
        <div>
            <kui-alert type="none" class="key-alert-wrapper bordered no-padding my-2">
                <kui-icon name="error-inline" class="dimmed-more" size="lg"></kui-icon>
                <span>{{ errorMessage }}</span>
            </kui-alert>
        </div>
    }

    @if (editing && showButtons) {
        <div class="buttons d-flex">
            <div class="flex-1">
                @for (action of editingActions; track action) {
                    <button kui-button (click)="onAction.emit(action.id || action.name)" color="secondary" kui-tooltip="action.name">
                        @if (action.icon) {
                            <kui-icon kui-action name="action.icon" [size]="'sm'"></kui-icon>
                        }
                        {{ action.name }}
                    </button>
                }
            </div>
            <div class="text-right">
                @if (!handler.buttons || handler.buttons.includes("cancel")) {
                    <button kui-button (click)="onCancel.emit()" color="secondary">
                        {{ "DIALOG.CANCEL" | translate }}
                    </button>
                }
                @if (!handler.buttons || handler.buttons.includes("save")) {
                    <button kui-button [disabled]="!saveable" (click)="onSave.emit()" color="primary">
                        {{ "DIALOG.SAVE" | translate }}
                    </button>
                }
                @if (handler.buttons && handler.buttons.includes("ok")) {
                    <button kui-button (click)="onSave.emit()" color="primary">
                        {{ "DIALOG.OK" | translate }}
                    </button>
                }
            </div>
        </div>
    }
</div>
